import type { ElementType } from 'react';
import { Callout } from './Callout';
import { Diagram } from './Diagram';
import { HelpImage } from './HelpImage';
import { Step, Steps } from './Steps';

export const mdxComponents: Record<string, ElementType> = {
  Callout,
  Diagram,
  HelpImage,
  Step,
  Steps,
};
